import React from "react";
import "./header.css";
import image1 from "../../assets/1.png";
import image2 from "../../assets/308.png";

import image3 from "../../assets/563.png";

// import {BsArrowRight} from 'react-icons/bs'

function Header() {
  return (
    <section id="#" className="container header_container">
      <div className="container_text">
        <div>
          <h2>
            Discover, collect and mint your own unique
            <strong> MonkeyDoo</strong> NFTs 🐵
          </h2>
          <h5>
            MonkeyDoo is deployed on the original Ethereum blockchain: Ethereum
            Classic.
          </h5>
        </div>
        <div>
          <div
            style={{
              marginBottom: "1rem",
            }}
          >
            <a href="/#minter">
              <button className="btn btn-primary">Mint Now !</button>
            </a>

            <a
              href="https://t.me/MonkeyDoo_NFT"
              target="_blank"
              style={{
                position: "relative",
                top: "9px",
              }}
            >
              <i
                className="fa fa-telegram"
                style={{
                  color: "rgb(254 111 162)",
                  fontSize: "35px",
                  margin: "7px",
                }}
              ></i>
            </a>
            <a
              href="https://twitter.com/MonkeyDoo_NFT?t=YtUCLKwoeuqsy5GUxIxxtQ&s=09"
              target="_blank"
              style={{
                position: "relative",
                top: "9px",
              }}
            >
              <i
                className="fa fa-twitter"
                style={{
                  color: "rgb(254 111 162)",
                  fontSize: "35px",
                  margin: "7px",
                }}
              ></i>
            </a>
            <a href="https://discord.gg/UhZFZHYwNx" target="_blank">
              <i
                className="fa fa-discord"
                style={{
                  color: "#ff779b",
                  fontSize: "30px",
                  position: "relative",
                  top: "9px",
                }}
              ></i>
            </a>
          </div>
        </div>
      </div>
      <div className="container_slides">
        <div className="slide_1">
          <img src={image1} />
        </div>
        <div className="slide_2">
          <img
            src={image2}
            style={{
              width: "260px",
              borderRadius: "40px",
              padding: "10px",
              marginBottom: "20px",
            }}
          />
          <img
            src={image3}
            style={{
              width: "260px",
              borderRadius: "40px",
              padding: "10px",
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default Header;
